import styled from "styled-components";

export const HousingSectionContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "16px",
  marginTop: "32px",

  [theme.breakpoint.lg()]: {
    gap: "40px",
    marginTop: "40px",
  },
}));
